import { useEffect, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { verifyAccount } from '../../../api-client/account'
import CloseX from '../../../components/svg/close-x'
import Checkmark from '../../../components/svg/checkmark'
import { Button } from '../../../components/button'

export const verificationStatusOptions = {
  pending: 0,
  rejected: 1,
  verified: 2,
}

export default function VerificationStatus({ onFinish, open, shouldPostVerificationRequest }) {
  const [errorDescription, setErrorDescription] = useState('')

  const {
    mutate,
    data: verificationStatusData,
    isLoading: isVerificationLoading,
    error: verificationError,
  } = useMutation(verifyAccount)

  useEffect(() => {
    if (open && shouldPostVerificationRequest) mutate()
  }, [open, shouldPostVerificationRequest, mutate])

  useEffect(() => {
    let nomatchedFields = ''

    if (verificationError?.errors[0]?.message !== null) {
      const fieldsKey = 'fields:'

      if (verificationError?.errors[0]?.message?.includes(fieldsKey)) {
        nomatchedFields = verificationError.errors[0].message.substring(
          verificationError.errors[0].message.indexOf(fieldsKey) + fieldsKey.length,
        )
      }
    }

    if (nomatchedFields !== '') {
      setErrorDescription(
        'Please check the entered personal data:' +
          nomatchedFields +
          '<br />or contact privauto support directly at <b>support@drivrzxchange.com</b> for manual verification with one of our helpful agents.',
      )
    } else {
      setErrorDescription(
        'Please contact privauto support directly at <b>support@drivrzxchange.com</b> for manual verification with one of our helpful agents.',
      )
    }
  }, [verificationError])

  return (
    <div className='wrapper'>
      {isVerificationLoading && (
        <div className='statusWrapper flex'>
          <div className='icon'>
            <div className='spinner' />
          </div>

          <div className='info'>
            <h3>Thank you for your verification submission.</h3>
            <p>We’re still confirming your identity this will be completed shortly.</p>
          </div>
        </div>
      )}

      {verificationError && (
        <div className='statusWrapper flex'>
          <div className='icon'>
            <CloseX fill='var(--alert-color)' />
          </div>

          <div className='info'>
            <h3>Sorry, we couldn't verify your ID</h3>
            <p dangerouslySetInnerHTML={{ __html: errorDescription }}></p>
          </div>
        </div>
      )}

      {verificationStatusData && (
        <div className='statusWrapper flex'>
          <div className='icon'>
            <Checkmark fill='var(--success-color)' />
          </div>

          <div className='info'>
            <h3>We’ve confirmed it’s you!</h3>
            <p>
              Your identity has been confirmed. Your account has full access to buying and selling
              vehicles.
            </p>
          </div>
        </div>
      )}

      <div className='nextBtnContainer flex justifyEnd'>
        <Button disabled={!verificationStatusData} onClick={onFinish}>
          Finish
        </Button>
      </div>

      <style jsx>{`
        .wrapper {
          .icon {
            width: 5.5rem;
            height: 5.5rem;
            margin: 0 2rem 0 0;

            :global(svg) {
              width: 100%;
              height: 100%;
            }
          }

          .info {
            h3 {
              line-height: 3.2rem;
              font-size: 2.4rem;
            }

            p {
              line-height: 2.1rem;
              font-size: 1.6rem;
            }
          }
        }

        .nextBtnContainer {
          margin: 7rem 0 0;
        }

        .spinner,
        .spinner:after {
          border-radius: 50%;
          width: 5.5rem;
          height: 5.5rem;
        }

        .spinner {
          margin: 0 auto;
          position: relative;
          border-top: 0.6rem solid var(--primary-color);
          border-right: 0.6rem solid var(--separator-line-color);
          border-bottom: 0.6rem solid var(--separator-line-color);
          border-left: 0.6rem solid var(--separator-line-color);
          animation: spin 1.1s infinite linear;
        }

        @media (max-width: 1024px) {
          .statusWrapper {
            flex-direction: column;
            align-items: center;
          }

          .wrapper {
            margin: 0.72rem 0 0;

            .info {
              margin: 2rem 0 0;
              text-align: center;

              h3 {
                line-height: 2.4rem;
                font-size: 1.8rem;
              }

              p {
                line-height: 1.9rem;
                font-size: 1.4rem;
              }
            }
          }

          .nextBtnContainer {
            margin: 3rem 0 0;

            :global(button) {
              width: 100%;
            }
          }
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  )
}
